<template>
  <div>
    <b-alert
      show
      variant="dark"
      class="margin-bottom font12px"
      v-if="
        this.OpdHistoryPrintData != '' &&
          this.OpdHistoryPrintData != '[]' &&
          this.OpdHistoryPrintData != 'null' &&
          this.OpdHistoryPrintData != null
      "
    >
      <h6>ขอประวัติการรักษา</h6>
      <b-list-group>
        <b-list-group-item
          button
          v-for="item in OpdHistoryPrintData"
          v-bind:key="item.id"
          class="OpdHistoryPrintCSS"
        >
          <b-row>
            <b-col cols="10" class="text-left">
              <div class="padding-left20px">
                {{ item.datas.vstdate + " " + item.datas.vsttime }} |
                {{ item.datas.department }} | {{ item.datas.doctor_name }}
              </div>
            </b-col>
            <b-col cols="2" class="text-right">
              <div class="padding-right20px">
                <div @click="HistoryPrintDelete(item.datas.vn)">
                  <v-icon name="delete" class="icon-delete"></v-icon>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>

      <b-row class="text-center margin-top4px">
        <b-col>
          <b-badge
            variant="primary"
            class="font14px"
            href="#"
            @click="HistoryPrintShow(ptHN)"
            >พิมพ์ประวัติการรักษา</b-badge
          >
        </b-col>
        <b-col>
          <b-badge
            variant="danger"
            class="font14px"
            href="#"
            @click="HistoryPrintDeleteAll(ptHN)"
            >ลบทั้งหมด</b-badge
          >
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScan from "@/models/patientEMRs/DocumentScan";
import PatientOpdHistoryPrintData from "@/models/patientEMRs/PatientOpdHistoryPrintData";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDocGroup: null,
      TmpDocData: null,
      TmpLocation: null,
      ptHN: "",
      OpdHistoryPrintDataLoadSTD: false,
      OpdHistoryPrintData: []
    };
  },
  props: ["MyHn", "PtHistoryprint"],
  component: {
    thaiDatetime,
    pjFunctions,
    DocumentScan,
    PatientWebbaseUrl
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods);
    this.hnChang;
  },
  watch: {
    ptHN: function() {
      if (
        this.ptHN != null &&
        this.ptHN != undefined &&
        this.ptHN != "undefined"
      ) {
        this.loadOpdHistoryPrintData(this.ptHN);
      }
    },
    PtHistoryprint: function() {
      if (
        this.ptHN != null &&
        this.ptHN != undefined &&
        this.ptHN != "undefined"
      ) {
        this.getOpdHistoryPrintData(this.ptHN);
      }
    }
  },
  computed: {
    hnChang() {
      if (
        this.MyHn != null &&
        this.MyHn != undefined &&
        this.MyHn != "undefined"
      ) {
        this.ptHN = this.MyHn;
      }
    }
  },
  methods: {
    HistoryPrintDeleteAll(hn) {
      let STD = PatientOpdHistoryPrintData.delete({
        where(record) {
          return record.hn == hn;
        }
      });
      store.set("systems@ptHistoryPrint", STD);
    },
    HistoryPrintDelete(vn) {
      let STD = PatientOpdHistoryPrintData.delete({
        where(record) {
          return record.vn == vn;
        }
      });
      store.set("systems@ptHistoryPrint", STD);
    },
    loadOpdHistoryPrintData(hn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Patient Opd History PrintData ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintData",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientOpdHistoryPrintData.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            let dtID = 0;
            for (val of DataLoadObj.output.result) {
              if (
                val.vstdate != "" &&
                val.vstdate != "null" &&
                val.vstdate != null &&
                val.vsttime != "" &&
                val.vsttime != "null" &&
                val.vsttime != null
              ) {
                dtID = DataLoadObj.thaiDatetimeFc.DateTimeId(
                  val.vstdate + " " + val.vsttime
                );
              }

              data.push({
                id: val.loginname + val.vn,
                loginname: val.loginname,
                hn: val.hn,
                vn: val.vn,
                log_datetime: val.log_datetime,
                datas: val,
                visit_orderby: dtID
              });
            }

            PatientOpdHistoryPrintData.insertOrUpdate({
              data
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdHistoryPrintData.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("PatientOpdHistoryPrintData : " + DataLoadObj.output);
        })
        .finally(function() {
          DataLoadObj.OpdHistoryPrintDataLoadSTD = true;
          DataLoadObj.getOpdHistoryPrintData(hn);
        });
    },
    getOpdHistoryPrintData(hn) {
      let Obj5 = PatientOpdHistoryPrintData.query()
        .where(record => record.hn == hn)
        .where(
          record =>
            record.loginname == this.$store.get("systems@LoginData").UserId
        )
        .orderBy("visit_orderby", "desc")
        .get();

      this.OpdHistoryPrintData = Obj5;
    },
    HistoryPrintShow(hn) {
      let Obj5 = PatientOpdHistoryPrintData.query()
        .where(record => record.hn == hn)
        .where(
          record =>
            record.loginname == this.$store.get("systems@LoginData").UserId
        )
        .orderBy("visit_orderby", "desc")
        .get();

      let RequestData = {
        CompanyId: this.$store.get("systems@CompanyId"),
        ApiKey: this.$store.get("systems@ApiKey"),
        hn: hn,
        vn: "",
        vn_list: Obj5
      };

      let ScrObj = this;
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintSave",
          RequestData
        )
        .then(function(response) {
          ScrObj.output = response.data;

          // console.log(ScrObj.output);
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("PatientOpdHistoryPrintSave : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.HistoryPrintOpen(hn);
        });
    },
    HistoryPrintOpen(hn) {
      let EmrPrintUrlObj = PatientWebbaseUrl.query()
        .where(record => record.web_name == "EMR_VIEW_NEW_PRINT")
        .get();

      let param = { hn: hn, uuss: this.$store.get("systems@LoginData").UserId };

      if (EmrPrintUrlObj.length > 0) {
        let EmrPrintUrl =
          EmrPrintUrlObj[0].web_host +
          "smpk_emr/emr_view_visit_opd_history_print.php?hn=" +
          hn;

        this.pjFunctionsFc.OpenWindowWithPost(
          EmrPrintUrl,
          "width=1100,height=600,left=100,top=10,resizable=yes,scrollbars=yes",
          "NewFile",
          param
        );
      }
    }
  }
})
export default class EmrOpdHistoryPrint extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
.OpdHistoryPrintCSS {
  padding: 4px !important;
}

.icon-delete {
  margin-top: -2px;
  width: 20px;
  color: #bd2130;
}
</style>

